import styled from 'styled-components'

export const AppWrapper = styled.div`
  height: 100%;
`
